import React from 'react'

function TextareaWithCounter(props) {
    let count   = props.count.length;
    let max     = props.maxlength;

  return (
    <div className='content-textarea-with-counter'>
        <textarea 
            {...props} 

            rows="4"
            className="form-control text-filter__form-control" 
            style={{ minHeight: "auto", maxHeight: "500px" }}
        ></textarea>
        <span className={((count >= max) ? "text-danger" : "" )+ " font-weight-bold counter"}>
            {count}
        </span>
    </div>
  )
}

export default TextareaWithCounter